type HistoryNavigation = { delta: number }

let activeGuard: ((navigation: HistoryNavigation) => void) | null = null
let currentHistoryIndex = typeof window.history.state?.idx === "number" ? window.history.state.idx : null
let allowNextHistoryNavigation = false
let installed = false

export function installNavigationGuard() {
  if (installed) return
  installed = true
  window.addEventListener("popstate", (event) => {
    const nextHistoryIndex = typeof event.state?.idx === "number" ? event.state.idx : null
    if (allowNextHistoryNavigation || !activeGuard || currentHistoryIndex === null || nextHistoryIndex === null) {
      allowNextHistoryNavigation = false
      currentHistoryIndex = nextHistoryIndex
      return
    }
    const delta = nextHistoryIndex - currentHistoryIndex
    if (!delta) return
    event.stopImmediatePropagation()
    activeGuard({ delta })
    allowNextHistoryNavigation = true
    window.history.go(-delta)
  })
}

export function registerNavigationGuard(guard: (navigation: HistoryNavigation) => void) {
  activeGuard = guard
  currentHistoryIndex = typeof window.history.state?.idx === "number" ? window.history.state.idx : currentHistoryIndex
  return () => { if (activeGuard === guard) activeGuard = null }
}

export function continueHistoryNavigation(delta: number) {
  allowNextHistoryNavigation = true
  window.history.go(delta)
}
